<template>
  <div class="ci-alert">
    <h1>404 NOT FOUND</h1>
  </div>
</template>

<script>
export default {
  name: 'notFound'
}
</script>



// WEBPACK FOOTER //
// notFound.vue?3eef5912